<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="true"
    [title]="pageTitle" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (loaded) {
      @if (currentProposals?.length === 0) {
        <tidy-alert>
          <tidy-text
            [body]="('No ' | translate) + status + (' proposals' | translate)" />
        </tidy-alert>
      }
      @for (proposal of currentProposals; track proposal) {
        <tidy-card>
          <tidy-card-button (action)="goToProposalPage(proposal)">
            <tidy-row>
              <tidy-image
                [src]="'assets/img/proposals-black.svg'"
                class="body-size" />
              <tidy-text
                [header]="proposal?.proposable?.team_service?.name | titlecase"
                [translate]="false" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Sent'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="proposal?.created_at | parseDateTime:'MMM d':'local'" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="'by'" />
                  <tidy-text
                    [body]="proposal?.team?.owner?.first_name"
                    [translate]="false" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }
        }

      </tidy-wrapper>
    </ng-template>

    <app-scroll-wrapper [templateContent]="content" />
